/*
 * @Description: Http请求模块
 * @Author: Mars
 * @Date: 2023-11-30 17:01:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024/10/10
 */
import { saveBlob } from '@/utils/common';
import request, { IRequestOption } from '@/utils/request';

/** blob 响应经 request 拦截器处理后的形状 */
interface IBlobResult {
  blob: Blob;
  fileName?: string;
}

/**
 * 导出文件：后端出错时仍按 200 返回 JSON，此时 blob 的类型是 application/json，需要解析出来 reject。
 * download 为 false 时只返回 blob 不触发下载（如图片预览）。
 */
const exportFile = async (option: IRequestOption, method: 'get' | 'post', fileName?: string, download = true) => {
  const res = await request.request<unknown, IBlobResult>({
    method,
    headers: { Accept: 'x-www-form-urlencoded' },
    responseType: 'blob',
    timeout: 10 * 60 * 1000,
    ...option,
  });
  if (res.blob.type === 'application/json') {
    return Promise.reject(JSON.parse(await res.blob.text()));
  }
  if (download) saveBlob(res.blob, fileName || res.fileName || 'file');
  return res.blob;
};

const http = {
  get: <T>(option: IRequestOption) => request.request<unknown, T>({ method: 'get', ...option }),
  post: <T>(option: IRequestOption) => request.request<unknown, T>({ method: 'post', ...option }),
  put: <T>(option: IRequestOption) => request.request<unknown, T>({ method: 'put', ...option }),
  delete: <T>(option: IRequestOption) => request.request<unknown, T>({ method: 'delete', ...option }),
  exportFileGet: (option: IRequestOption, fileName?: string, download = true) => exportFile(option, 'get', fileName, download),
  exportFilePost: (option: IRequestOption, fileName?: string, download = true) => exportFile(option, 'post', fileName, download),
};

export default http;
